import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { sendBroadcast } from '../../redux/actions/broadcast/sendBroadcast';
import { format } from 'date-fns';

import SelectionPerformer from '../../pages/SelectionPerformer';
import { getCandidateList } from '../../redux/actions/broadcast/getCandidateList';
import { toast } from 'react-toastify';
import { resetClearCandidateList, resetSendBroadcast } from '../../redux/slices/broadcast.slice';
import Loading from '../Loading/Loading';
import { clearCandidateList } from '../../redux/actions/broadcast/clearCandidateList';
import { resetAcceptModeration, resetGetVacancySingle } from '../../redux/slices/dashboard.slice';
import { acceptModeration } from '../../redux/actions/dashborad/acceptModeration';
// const { RangePicker } = DatePicker;

function BroadCastModal({ form, open, buttonState, onClose }) {
  const broadcastTypeOptions = [
    {
      value: 'public',
      label: 'Общедоступное',
    },
    {
      value: 'match',
      label: 'Синхронизированное',
    },
    {
      value: 'selected',
      label: 'По выборке',
    },
  ];
  const [openSelected, setOpenSelected] = useState(false);
  const {
    getVacancySingle: { data: getVacancySingleData, error: getVacancySingleError, loading: getVacancySingleLoading },
    acceptModeration: { data: acceptModerationData, error: acceptModerationError, loading: acceptModerationLoading },
  } = useSelector((state) => state.dashboard);
  const [activeTranslation, setActiveTranslation] = useState(false);
  useEffect(() => {
    if (getVacancySingleData) {
      setActiveTranslation(getVacancySingleData?.broadcast_from != null && getVacancySingleData?.broadcast_until != null && !getVacancySingleData?.is_broadcast && !getVacancySingleData?.is_verified);
    }
  }, [getVacancySingleData]);

  const { id } = useParams();
  useEffect(() => {
    form.register('candidates', {
      validate: (val, fullVal) => {
        if (fullVal?.broadcast_type == 'selected' && !val?.length) {
          return 'Выберите исполнителей';
        }
      },
    });
    dispatch(getCandidateList(id));
    return () => {
      dispatch(resetGetVacancySingle());
    };
  }, []);

  const {
    sendBroadcast: { data: sendBroadcastData, error: sendBroadcastError, loading: sendBroadcastLoading },
    getCandidateList: { data: getCandidateListData, error: getCandidateListError, loading: getCandidateListLoading },
    clearCandidateList: { data: clearCandidateListData, error: clearCandidateListError, loading: clearCandidateListLoading },
  } = useSelector((state) => state.broadcast);
  useEffect(() => {
    if (acceptModerationData) {
      onTranslate(form.getValues());
      dispatch(resetAcceptModeration());
    }
  }, [acceptModerationData]);

  const onReset = () => {
    if (getVacancySingleData?.is_broadcast || getVacancySingleData?.is_verified) {
      onClose();
    } else {
      const formatData = { broadcast_type: 'public', broadcast_from: null, broadcast_until: null, is_broadcast: false, broadcast_notify: false };
      dispatch(sendBroadcast({ data: formatData, vacancyId: id }));
    }
  };
  useEffect(() => {
    if (sendBroadcastError?.error?.length) {
      sendBroadcastError?.error?.map((err) => {
        toast.error(err, { theme: 'colored', autoClose: '3000' });
      });
    }
  }, [sendBroadcastError]);
  console.log(sendBroadcastError);
  const navigate = useNavigate();
  useEffect(() => {
    if (sendBroadcastData) {
      if (sendBroadcastData?.broadcast_from == null && sendBroadcastData?.broadcast_until == null) {
        form.setValue('broadcast_type', 'public');
        form.setValue('broadcast_from', null, { shouldDirty: true });
        form.setValue('broadcast_until', null, { shouldDirty: true });
        form.setValue('broadcast_notify', false);
        setTimeout(() => {
          form.clearErrors('broadcast_until');
          form.clearErrors('broadcast_from');
        }, 100);
        if (!getVacancySingleData?.is_broadcast) {
          setActiveTranslation(false);
        } else {
          onClose();
          if (getVacancySingleData?.is_hr) {
            navigate('/vacancy');
          } else {
            navigate('/vacancy');
          }
        }

        toast.success('Параметры трансляции сброшены', { theme: 'colored', autoClose: '3000' });
        dispatch(clearCandidateList(id));
      } else {
        if (sendBroadcastData?.is_broadcast) {
          if (!getVacancySingleData?.is_broadcast) {
            onClose();
            if (getVacancySingleData?.is_hr) {
              navigate('/vacancy');
            } else {
              navigate('/vacancy');
            }
          }
          toast.success(getVacancySingleData?.is_broadcast ? 'Параметры трансляции сохранены' : 'Трансляция запущена', { theme: 'colored', autoClose: '3000' });
        } else {
          if (!getVacancySingleData?.is_verified) {
            setActiveTranslation(true);
          }
          toast.success('Параметры трансляции сохранены', { theme: 'colored', autoClose: '3000' });
          if (sendBroadcastData?.broadcast_type !== 'selected') {
            dispatch(clearCandidateList(id));
          }
        }
      }

      dispatch(resetSendBroadcast());
    }
  }, [sendBroadcastData]);

  useEffect(() => {
    if (getCandidateListData) {
      form.setValue('candidates', getCandidateListData?.candidates);
      form.trigger();
    }
  }, [getCandidateListData]);

  const dispatch = useDispatch();
  useEffect(() => {}, []);

  const broadcast_type = form?.watch('broadcast_type');

  useEffect(() => {
    if (clearCandidateListData) {
      dispatch(getCandidateList(id));
      dispatch(resetClearCandidateList());
    }
  }, [clearCandidateListData]);
  const onSubmit = (data) => {
    const formatData = { ...data, broadcast_from: format(data.broadcast_from, 'yyyy-MM-dd'), broadcast_until: format(data.broadcast_until, 'yyyy-MM-dd'), is_broadcast: getVacancySingleData?.is_broadcast ? true : false };
    dispatch(sendBroadcast({ data: formatData, vacancyId: id }));
  };
  const onTranslate = (data) => {
    const formatData = { ...data, broadcast_from: format(data.broadcast_from, 'yyyy-MM-dd'), broadcast_until: format(data.broadcast_until, 'yyyy-MM-dd'), is_broadcast: true };
    dispatch(sendBroadcast({ data: formatData, vacancyId: id }));
  };
  const onSubmitTranslate = (data) => {
    dispatch(acceptModeration(id));
    // const formatData = { ...data, broadcast_from: format(data.broadcast_from, 'yyyy-MM-dd'), broadcast_until: format(data.broadcast_until, 'yyyy-MM-dd'), is_broadcast: true };
    // dispatch(sendBroadcast({ data: formatData, vacancyId: id }));
  };
  const errorDateFrom = form?.formState?.errors?.broadcast_from;
  const errorDateUntil = form?.formState?.errors?.broadcast_until;
  const errorCandidates = form?.formState?.errors?.candidates;
  useEffect(() => {
    if (!open) {
      dispatch(resetSendBroadcast());
    }
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <>
      {' '}
      <Modal title={`Параметры трансляции`} centered open={open} width={800} onCancel={onClose} footer={['']}>
        {(sendBroadcastLoading || clearCandidateListLoading) && (
          <>
            <div className="fixed t-0 l-0 r-0 b-0 z-50 w-[100vw] h-[100vh]"> </div>
            <div className="absolute  w-[32px] h-[32px] right-4 bottom-[30px]  left-1/2 -translate-x-1/2 bg-white">
              <Loading />
            </div>
          </>
        )}
        <Modal
          className="select-user-modal"
          style={{ height: 'calc(100vh - 40px)' }}
          title={``}
          centered
          open={openSelected}
          width={'100%'}
          onCancel={() => {
            setOpenSelected(false);
          }}
          footer={['']}>
          <SelectionPerformer
            onClose={() => {
              setOpenSelected(false);
            }}
          />
        </Modal>
        <div className="mx-auto p-6 flex flex-col w-full">
          <div className="relative mb-6">
            <select
              className="peer p-4 pe-9 block w-full border-1 border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none
                        focus:pt-6
                        focus:pb-2
                        [&:not(:placeholder-shown)]:pt-6
                        [&:not(:placeholder-shown)]:pb-2
                        autofill:pt-6
                        autofill:pb-2
                        outline-none"
              {...form?.register('broadcast_type')}>
              {broadcastTypeOptions?.map((item) => (
                <option value={item?.value}>{item?.label} </option>
              ))}
            </select>
            <label
              className="absolute top-0 start-0 p-4 h-full truncate pointer-events-none transition ease-in-out duration-100 border border-transparent peer-disabled:opacity-50 peer-disabled:pointer-events-none
                        peer-focus:text-xs
                        peer-focus:-translate-y-1.5
                        peer-focus:text-gray-500
                        peer-[:not(:placeholder-shown)]:text-xs
                        peer-[:not(:placeholder-shown)]:-translate-y-1.5
                        peer-[:not(:placeholder-shown)]:text-gray-500">
              Тип трансляции
            </label>
          </div>

          {broadcast_type === 'selected' ? (
            <div className="mb-6 ">
              <button
                className={clsx(
                  'text-center border rounded py-2 px-4 text-button hover:border-button border-button border-1 w-full hover:text-white bg-white hover:bg-button transition ease-in-out duration-300',
                  errorCandidates && 'border-red-300 focus:border-red-500 placeholder:text-red-400 text-red-500',
                )}
                onClick={() => {
                  setOpenSelected(true);
                }}>
                {getCandidateListData?.candidates?.length ? (
                  <>
                    Выбрано исполнителей{' '}
                    <span style={{ background: 'rgb(0 178 164 / var(--tw-bg-opacity))', color: '#fff' }} className={'ml-1 inline-block border border-button border-1 rounded  leading-[20px] p-[2px_4px_0px_4px] leading-[19px] bg-green transform'}>
                      {getCandidateListData?.candidates?.length}
                    </span>
                  </>
                ) : (
                  'Выборка исполнителей'
                )}
              </button>
              {errorCandidates && <div className="text-sm text-red-400 mt-1">{errorCandidates?.message}</div>}
            </div>
          ) : (
            <></>
          )}

          <div className="mb-6 flex items-center">
            <input type="checkbox" className="w-4 h-4 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none" id="hs-checkbox-group-1" {...form?.register('broadcast_notify')} />
            <label htmlFor="hs-checkbox-group-1" className="text-sm md:text-base ms-3">
              Уведомить соискателей
            </label>
          </div>

          {/* <div className="mb-6">
          <RangePicker size="large" />
        </div> */}

          <div className="flex flex-col md:flex-row mb-6 gap-2 md:gap-8">
            <div className="w-full mb-6">
              <input
                type="date"
                className={clsx(' border rounded py-2 px-4 text-gray-500 border-1 border-button outline-none w-full bg-white  transition ease-in-out duration-300', errorDateFrom && 'border-red-300 focus:border-red-500 placeholder:text-red-400')}
                {...form.register('broadcast_from', { required: { value: true, message: 'Обязательное поле' } })}
              />
              {errorDateFrom && <div className="text-sm text-red-400 mt-1">{errorDateFrom?.message}</div>}
            </div>
            <div className="w-full mb-6">
              {' '}
              <input
                type="date"
                className={clsx(' border rounded py-2 px-4 text-gray-500 border-1 border-button outline-none w-full bg-white  transition ease-in-out duration-300', errorDateUntil && 'border-red-300 focus:border-red-500 placeholder:text-red-400')}
                {...form.register('broadcast_until', { required: { value: true, message: 'Обязательное поле' } })}
              />{' '}
              {errorDateUntil && <div className="text-sm text-red-400 mt-1">{errorDateUntil?.message}</div>}
            </div>
          </div>

          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-1/2 md:py-3 md:pr-4">
              {activeTranslation ? (
                <button className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov w-full  transition ease-in-out duration-300" onClick={form.handleSubmit(onSubmitTranslate)}>
                  Транслировать
                </button>
              ) : (
                <button className="text-center border rounded py-2 px-4 mb-6 text-button border-button border-1 w-full hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" onClick={form.handleSubmit(onSubmit)}>
                  Сохранить изменения
                </button>
              )}
            </div>
            <div className="w-full md:w-1/2 md:py-3 md:pl-4">
              <button className="text-center border rounded py-2 px-4 mb-6 text-button border-button border-1 w-full hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" onClick={onReset}>
                Отмена
              </button>
            </div>
            {/* {
                        !buttonState ?
                            <div className='w-1/2 py-3 pl-4'>
                                <button 
                                    className='text-center border rounded py-2 px-4 mb-6 text-button border-button border-1 w-full hover:text-white bg-white hover:bg-button transition ease-in-out duration-300'
                                >
                                    Транслировать
                                </button>
                            </div> 
                            :
                            <div className='w-1/2 py-3 pl-4'>
                                <button 
                                    className='text-center border rounded py-2 px-4 mb-6 text-button border-button border-1 w-full hover:text-white bg-white hover:bg-button transition ease-in-out duration-300'
                                    onClick={onClose}
                                >
                                    Отмена
                                </button>
                            </div> 
                    } */}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default BroadCastModal;
